import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
  useMediaQuery,
  Container,
  Box,
  Grid,
  Typography,
  FormControl,
  TextField,
} from '@mui/material';

import TemplateMessage from './components/TemplateMessage';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../constants/FirestoreCollections';
import { toUpper } from 'lodash';
import { useSelector } from 'react-redux';
import { Reorder, Add } from '@mui/icons-material';
import Text from '../../shared/Text';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    templates: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
    },
    title: {
      fontSize: theme.sizes.md.t3,
    },
    addButton: {
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 50,
      width: 50,
      cursor: 'pointer',
      background: theme.palette.primary.main,
      '&:hover': {
        background: theme.palette.primary.light,
      },
    },
  }));
};

export default function TemplateMessages() {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const organization = useSelector((state) => state.app.organization);
  const profile = useSelector((state) => state.firebase.profile);
  const configuration = useSelector((state) => state.app.labelsConfiguration);
  const [showAddTemplate, setShowAddTemplate] = useState();
  const [templates, setTemplates] = useState([]);
  const firestore = useFirestore();
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (organization && organization.id) {
      if (profile && profile.claims && profile.claims.includes('admin')) {
        firestore
          .collection(collections.templates)
          .get()
          .then((res) => {
            const _templates = [];
            res.forEach((e) => {
              _templates.push({ id: e.id, ...e.data() });
            });
            setTemplates(
              _templates.filter((e) => e.organizationId === organization.id || e.global),
            );
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
          });
      } else {
        firestore
          .collection(collections.templates)
          .where('organizationId', '==', organization.id)
          .where('global', '==', false)
          .get()
          .then((res) => {
            const _templates = [];
            res.forEach((e) => {
              _templates.push({ id: e.id, ...e.data() });
            });
            setTemplates(_templates);
          });
      }
    }
  }, [firestore, organization, organization.templateMessages, profile]);

  const newTemplateMessage = (message, callback) => {
    const newMessage =
      profile && profile.claims && profile.claims.includes('admin')
        ? {
            ...message,
            message: message.message.trim(),
            organizationId: organization.id,
            global: !!message.global,
          }
        : {
            ...message,
            message: message.message.trim(),
            organizationId: organization.id,
            global: false,
          };

    firestore
      .collection(collections.templates)
      .add({ ...newMessage })
      .then(
        (res) => {
          setTemplates([{ ...newMessage, id: res.id }, ...templates]);
          callback();
        },
        (err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          callback();
        },
      );
  };

  const updateTemplateMessage = (message, index, callback) => {
    firestore
      .collection(collections.templates)
      .doc(message.id)
      .update(message)
      .then(
        () => {
          callback();
          setTemplates(templates.map((m) => (m.id === message.id ? message : m)));
        },
        (_) => {
          callback();
        },
      );
  };

  const handleSubmit = (message, mode, index, callback) => {
    switch (mode) {
      case 'create':
        newTemplateMessage(message, callback);
        break;
      case 'update':
        updateTemplateMessage(message, index, callback);
        break;
      default:
        throw new Error(`System messages mode of value ${mode} is unexpected`);
    }
  };

  const handleDelete = (message, callback) => {
    firestore
      .collection(collections.templates)
      .doc(message.id)
      .delete()
      .then((res) => {
        setTemplates(templates.filter((e) => e.id !== message.id));
        callback();
      });
  };

  return (
    <div>
      <div className={classes.appBarSpacer} />
      <Container className={classes.templates} maxWidth="lg">
        <Grid container display="flex" justifyContent="center">
          <Grid item xs={12} sm={10}>
            <Grid item xs={12}>
              <Box className={classes.titleLy}>
                <Box pb={2} display="flex" alignItems="center">
                  <Box pr={1}>
                    <Reorder />
                  </Box>
                  <Typography className={classes.title}>Plantillas</Typography>
                </Box>
                {configuration && configuration.templates && (
                  <Text configuration={configuration} propName="templates" />
                )}
              </Box>
            </Grid>
            <Grid>
              <Grid width="100%" alignItems="center" container>
                <Grid item xs={8} sm={3}>
                  <FormControl fullWidth>
                    <TextField
                      id="standard-basic"
                      label="Buscar"
                      variant="outlined"
                      onChange={(event) => setSearchValue(event.target.value)}
                    />
                  </FormControl>
                </Grid>
                {!showAddTemplate && (
                  <Box ml={2}>
                    <Box className={classes.addButton} onClick={() => setShowAddTemplate(true)}>
                      <Add />
                    </Box>
                  </Box>
                )}
              </Grid>
              {showAddTemplate && (
                <TemplateMessage
                  mode="create"
                  templateMessage={{}}
                  index={-1}
                  // eslint-disable-next-line no-undef
                  onSubmit={handleSubmit}
                  // eslint-disable-next-line no-undef
                  onDelete={handleDelete}
                  // eslint-disable-next-line no-undef
                  onCancel={() => setShowAddTemplate(false)}
                />
              )}
              {templates
                .filter((templateMessage) => {
                  return !searchValue
                    ? true
                    : toUpper(templateMessage.value).indexOf(toUpper(searchValue)) !== -1;
                })
                .map((template, index) => (
                  <TemplateMessage
                    key={index}
                    mode="update"
                    templateMessage={template}
                    index={index}
                    onSubmit={handleSubmit}
                    onDelete={handleDelete}
                  />
                ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
